<!-- 开发设置 --  数据迁移 -- 数据迁移计划 -- 计划明细 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:3537,
        name:"计划明细",
        parentId:"PLAN_ID",
        parentName:"数据迁移计划",
        parentPath:"/system/trans/outerPlan",
        dataClass:2,
        implementRowClick,
        parentQuery:{
        },
        addForm:{
        },
        col:[],
        sjqyRowClick
      }'
    >
    </Table>
  </div>
</template>

<script>
import {post} from "@/api/table/table";
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    Table
  },
  data() {
    return {
      firstEnter:true,
    };
  },
  computed: {
  },
  methods: {
    // 行按钮 执行
    implementRowClick(btn,row){
      post("/api/blade-develop/dbouter/excutePlantDtlByid",this.$qs.stringify({id:row.ID})).then(res=>{
        console.log(res);
        this.$message.success(res.data.msg);
      })
    },
    sjqyRowClick(btn,row){
      this.$router.push({
        path: "/system/trans/outerSetup",
        query: {
          runId: this.$route.query.runId,
          TRANSDATA_ID:row.TRANSDATA_ID
        },
      });
    },
  },
  created(){
  },
  activated(){
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }
};
</script>

<style></style>
